export const BRAND_PREFIXES_CONSTANTS = {
    PREFIX: 'cl_',
};
